import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import {IconButton} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';



export const AlertBox = ({type,msg}) => {
 
  const [open, setOpen] = React.useState(true); 

  return (
    <Alert
      severity={type}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {msg}
        </Alert>
  )
}

